import { render } from "./CancelMandateModal.vue?vue&type=template&id=5164ce0c"
import script from "./CancelMandateModal.vue?vue&type=script&lang=js"
export * from "./CancelMandateModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CancelMandateModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_881c333e%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fmandate%2FCancelMandateModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__